import APITemplate from '@api/APITemplate'
import { formatQueryParams } from '@utils/Format'
import store from '@state/store'
import con from '@services/connection'
import { atualizar } from '@constants/URL'
import { GlobalBus } from '@services/bus'
import { RUNNING, STOP } from '@constants/Text'

class APIConsolidatorCotizacao extends APITemplate {
  constructor() {
    super()
    this.TIME_WAIT = 15000
    this.timeoutLoad = null
    this.pollingClientId = null
  }
  async run({ id_cliente }) {
    console.log('[COTIZACAO] INICIANDO ', id_cliente)
    const data = {
      id_cliente_app: id_cliente,
    }
    this.clearTimeout()
    const r = await con.post(atualizar.professional, data)
    if (!this._isSelectedClient(id_cliente)) return
    if (r && r.status === 200) {
      this._scheduleRetry(id_cliente)
    }
  }

  _isSelectedClient(id_cliente) {
    const currentClient = store.getters['user/currentClient']
    return !!currentClient && id_cliente === currentClient.id
  }

  async checkStatus({ id_cliente }) {
    console.log('[COTIZACAO] CHECK STATUS ', id_cliente)
    if (!this._isSelectedClient(id_cliente)) {
      console.warn(
        'Tentativa de buscar o status da cotizacao para um cliente diferente do selecionado'
      )
      this.clearTimeout()
      this.stop(id_cliente)
      return
    }
    const params = { id_cliente_app: id_cliente }
    const r = await con.get(
      atualizar.professional_status + formatQueryParams(params)
    )
    console.log('[COTIZACAO] check status ', r)
    if (!this._isSelectedClient(id_cliente)) return
    if (r && r.status === 200 && !r.value.atualizando) {
      this.success(id_cliente)
    } else {
      this._scheduleRetry(id_cliente)
    }
  }

  async restoreStatus({ id_cliente }) {
    if (!id_cliente) return
    if (this.pollingClientId === id_cliente) return
    if (this.pollingClientId) {
      this.clearTimeout()
      this.stop(this.pollingClientId)
    }
    const params = { id_cliente_app: id_cliente }
    const r = await con.get(
      atualizar.professional_status + formatQueryParams(params)
    )
    if (!this._isSelectedClient(id_cliente)) return
    if (r && r.status === 200 && r.value && r.value.atualizando) {
      this._scheduleRetry(id_cliente)
    }
  }

  _scheduleRetry(id_cliente) {
    this.start(id_cliente)
    this.clearTimeout()
    this.timeoutLoad = setTimeout(() => {
      this.checkStatus({ id_cliente })
    }, this.TIME_WAIT)
  }

  clearTimeout() {
    clearTimeout(this.timeoutLoad)
  }

  start(id_cliente) {
    this.pollingClientId = id_cliente
    GlobalBus.$emit(RUNNING.COTIZACAO)
    store.dispatch('consolidator/setCotizacao', { id_cliente, loading: true })
    store.dispatch('consolidator/setCotizacaoLoading', true)
  }

  stop(id_cliente) {
    if (this.pollingClientId === id_cliente) this.pollingClientId = null
    GlobalBus.$emit(STOP.COTIZACAO)
    store.dispatch('consolidator/setCotizacaoLoading', false)
    store.dispatch('consolidator/setCotizacao', { id_cliente, loading: false })
  }

  success(id_cliente) {
    // GlobalBus.$emit(RELOAD.ASSETS)
    // Marcar desatualizado para os dados da carteira
    store.dispatch('consolidator/setClientDataOutdated', true)
    this.stop(id_cliente)
  }
}

const apiConsolidatorCotizacao = new APIConsolidatorCotizacao()
export { apiConsolidatorCotizacao }
